import {
  Box,
  Text,
  Input,
  Textarea,
  Button,
  Flex,
  Slider,
  SliderTrack,
  SliderFilledTrack,
  SliderThumb
} from "@chakra-ui/react";
import {
  FaArrowLeft,
  FaArrowRight,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Navbar from "../Components/Navbar";
import { useSurvey } from "./BusinessSurveyContext";
import { useState } from "react";
import { useEffect } from "react";

export default function BusinessInformation() {
  const navigate = useNavigate();
  const { surveyData, updateSurveyData } = useSurvey();
  const { years, employees, description } = surveyData || {};
  const [yearValue, setYearValue] = useState(
  Number.isFinite(years) ? years : -1
  );
  const [employeeValue, setEmployeeValue] = useState(
    Number.isFinite(employees) ? employees : -1
  );
  useEffect(() => {
  if (Number.isFinite(years)) setYearValue(years);
  if (Number.isFinite(employees)) setEmployeeValue(employees);
}, [years, employees]);

  const uiVal = (v) => (v < 0 ? 0 : v);
  const label = (v) => (v < 0 ? "Not set" : String(v));

  return (
    <Box minHeight="100vh" display="flex" flexDirection="column" bg="white">
      <Navbar />
      {/* Header */}
      <Box
        bg="#00C49A"
        height="80px"
        display="flex"
        alignItems="flex-end"
        justifyContent="center"
        pb={2}
      >
        <Text fontSize="lg" fontWeight="bold" color="black">
          RESOURCES
        </Text>
      </Box>

      {/* Main Content */}
      <Box
        flex="1"
        overflowY={["auto", "auto", "visible"]}
        px={4}
        pt={6}
        pb={["140px", "160px"]}
        display="flex"
        justifyContent="center"
        minHeight={{ base: "auto", md: "calc(100vh - 200px)" }}
      >
        <Box width="100%" maxW="480px">
          {/* Back Arrow */}

          {/* Title */}
          <Text fontWeight="bold" fontSize="xl" mb={1} textAlign={"center"}>
            Pilot Small Business Assistance Application Survey
          </Text>


          {/* Progress Bar */}
          <Box
            width="100%"
            maxW={{ base: "360px", md: "440px" }}
            mx="auto"
            mb={10}
            height="32px"
            border="2px solid black"
            borderRadius="full"
            overflow="hidden"
          >
            <Box
              width="48%"
              height="100%"
              bg="#00C49A"
              borderRightRadius="full"
            />
          </Box>

          {/* Form Fields */}
          <Box mb={12}>
          <Box mb={8}>
            <Text fontWeight="bold" fontSize="md" mb={2}>
              Years of Operation: {label(yearValue)}
            </Text>
            <Slider
              aria-label="slider"
              min={0}
              max={50}
              step={1}
              value={uiVal(yearValue)}
              onChange={(val) => {
                setYearValue(val);
                updateSurveyData({ years: val });
              }}
            >
              <SliderTrack bg="#E0E0E0">
                <SliderFilledTrack bg="#00C49A" />
              </SliderTrack>
              <SliderThumb bg="#00C49A" />
            </Slider>
          </Box>


          <Box mb={8}>
            <Text fontWeight="bold" fontSize="md" mb={2}>
              Number of Employees: {label(employeeValue)}
            </Text>
            <Slider
              aria-label="slider"
              min={0}
              max={100}
              step={1}
              value={uiVal(employeeValue)}
              onChange={(val) => {
                setEmployeeValue(val);
                updateSurveyData({ employees: val });
              }}
            >
              <SliderTrack bg="#E0E0E0">
                <SliderFilledTrack bg="#00C49A" />
              </SliderTrack>
              <SliderThumb bg="#00C49A" />
            </Slider>
          </Box>

            <Box mb={4}>
              <Text fontWeight="bold" fontSize="md" mb={2}>
                Brief Description of Your Business
              </Text>
              <Textarea
                placeholder="Enter text here...."
                variant="filled"
                bg="#E0E0E0"
                _focus={{
                  boxShadow: "none",
                  bg: "#E0E0E0",
                  borderBottom: "2px solid #00C49A",
                }}
                value={description || ""}
                onChange={(e) => updateSurveyData({ description: e.target.value })}
                borderBottom="2px solid #00C49A"
                borderRadius="md"
                fontStyle="italic"
                rows={4}
              />
            </Box>
          </Box>
        </Box>
      </Box>

      {/* Back/Next Buttons */}
      <Box
        position="absolute"
        bottom={["110px", "120px"]}
        width="100%"
        bg="white"
        py={3}
        px={6}
        display="flex"
        justifyContent="space-between"
        zIndex={10}
      >
        <Button
          variant="ghost"
          leftIcon={<FaArrowLeft color="#00C49A" />}
          color="black"
          onClick={() => navigate("/business-app-2")}
        >
          Back
        </Button>
        <Button
          variant="ghost"
          onClick={() => {
            if (!description || !description.trim()) {
              alert("Please enter a brief description of your business.");
              return;
            }
            if (yearValue < 0) {
              alert("Please set the Years of Operation.");
              return;
            }
            if (employeeValue < 0) {
              alert("Please set the Number of Employees.");
              return;
            }
            navigate("/business-app-4")
          }}
          rightIcon={<FaArrowRight color="#00C49A" />}
          color="black"
        >
          Next
        </Button>
      </Box>

      {/* Bottom Navigation */}
      <Flex
        position="fixed"
        bottom={0}
        width="100%"
        bg="white"
        py={3}
        justifyContent="space-around"
        borderTop="2px solid black"
        zIndex={5}
      >
      </Flex>
    </Box>
  );
}
